<section class="bread-block">
  <div class="container">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['']">Головна</a></li>
        <li class="breadcrumb-item"><a [routerLink]="['/portfolio']">Портфоліо</a></li>
        <li class="breadcrumb-item">Юніт Сіті</li>
      </ol>
    </nav>
  </div>
</section>

<section class="content-page my-2 my-lg-4">
  <div class="container">
    <div class="title title-zag-block">ЮНІТ СІТІ</div>
  </div>
</section>

<section class="slider">
  <div class="container">
    <div class="portfolio-owl owl-carousel owl-theme">
      <div class="slider-item">
        <img src="../../../assets/images/unit/unit_1.jpg" alt="Юнит сити"
             class="img-fluid">
      </div>
      <div class="slider-item">
        <img src="../../../assets/images/unit/unit_2.jpg" alt="Юнит сити"
             class="img-fluid">
      </div>
      <div class="slider-item">
        <img src="../../../assets/images/unit/unit_3.jpg" alt="Юнит сити"
             class="img-fluid">
      </div>
      <div class="slider-item">
        <img src="../../../assets/images/unit/unit_4.jpg" alt="Юнит сити"
             class="img-fluid">
      </div>
    </div>
  </div>
</section>
<section class="content-page my-2 my-lg-4">
  <div class="container">
    <p>Юніт сіті (м. Київ, вул. Сім'ї Хохлових, 8, Корпус В10 5-й поверх). Загальна площа: 1 395,82 м2</p>
  </div>
</section>
<section class="content-page my-2 my-lg-4">
  <div class="container">
    <div class="title title-zag-block">Проведені роботи</div>
    <ol>
      <li>Монтаж систем опалення (водяна двотрубна горизонтальна система опалення з внутрішньопідлоговими конвекторами)
      </li>
      <li>Монтаж систем припливно-витяжної вентиляції (загальна витрата повітря припливного: 13580 м3 год)</li>
      <li>Монтаж систем тепло-холодопостачання (холодильна потужність 163,6 кВт в тому числі 26,3 кВт - холодильна
        потужність повітроохолоджувачів вентиляційних установок, 137,3 кВт - холодильна потужність фанкойлів)
      </li>
    </ol>
  </div>
</section>

<app-our-advantages></app-our-advantages>
<app-our-clients-small></app-our-clients-small>
<app-feedback></app-feedback>
<app-map></app-map>
